import { useState } from "react";
import { recommendTags, recommendations } from "@/mocks/home";

export default function Recommendations() {
  const [activeTag, setActiveTag] = useState(recommendTags[0]);

  const filtered =
    activeTag === "全部"
      ? recommendations
      : recommendations.filter((item) => item.tags.includes(activeTag));

  return (
    <section id="more" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-10">
        <div className="mb-8 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="font-label text-xs tracking-widest text-primary-600">MORE</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              延伸推荐：看完之后可以继续浏览
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              如果正片看完了还想找点类似的内容，可以从下面的整理里挑一挑。用标签筛选即可收窄范围，筛选只作用于本页已有的条目。
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            {recommendTags.map((tag) => (
              <button
                key={tag}
                type="button"
                aria-pressed={activeTag === tag}
                onClick={() => setActiveTag(tag)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-label transition-colors cursor-pointer ${
                  activeTag === tag
                    ? "bg-secondary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="rounded-lg border border-background-200 bg-background-100/60 p-10 text-center">
            <i className="ri-inbox-line text-3xl text-foreground-400"></i>
            <p className="mt-3 text-sm text-foreground-600">该标签下暂时没有条目，试试其他标签。</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((item) => (
              <article
                key={item.id}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100/60 transition-colors hover:border-primary-300"
              >
                <div className="h-44 w-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title}的配图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex flex-wrap gap-2">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-label text-accent-800"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
                  <div className="mt-4 flex items-center gap-2 border-t border-background-200 pt-4 text-xs font-label text-foreground-500">
                    <i className="ri-play-list-line text-base text-primary-500"></i>
                    {item.meta}
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}